import { render, staticRenderFns } from "./downSoltList.vue?vue&type=template&id=069daf76&scoped=true&"
import script from "./downSoltList.vue?vue&type=script&lang=js&"
export * from "./downSoltList.vue?vue&type=script&lang=js&"
import style0 from "./downSoltList.vue?vue&type=style&index=0&id=069daf76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069daf76",
  null
  
)

export default component.exports